import { render } from "./StageButtonLink.vue?vue&type=template&id=be393694&scoped=true&ts=true&lang=pug"
import script from "./StageButtonLink.vue?vue&type=script&lang=ts&setup=true"
export * from "./StageButtonLink.vue?vue&type=script&lang=ts&setup=true"

import "./StageButtonLink.vue?vue&type=style&index=0&id=be393694&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be393694"]])

export default __exports__